import { getTasksTranslation } from '@bridebook/web/lib/countries/data/tasks';
import { getMenu } from '@bridebook/web/lib/ui/menu';

type Section = { title: string; url: string };

// "[budget]" with no address after it names an app section.
const SECTION_LINK = /\[([A-Za-z]+)\](?!\()/g;

/**
 * Turns the short links to app sections, as in "[budget]", into full markdown links with
 * the section's title and path, so every link in a name has one form. A name the app has
 * no section for stays as plain text, as on the checklist page.
 */
export const expandSectionLinks = (text: string, sections: Record<string, Section>): string =>
  text.replace(SECTION_LINK, (_, name: string) => {
    const section = sections[name];
    return section ? `[${section.title}](${section.url})` : name;
  });

/**
 * Template task names as the checklist page shows them: in the couple's language, with
 * markdown links. The template's own names carry the CMS link markup, so a task without a
 * translation keeps its template name.
 */
export const taskNameTranslator = (): ((i18nKey: string | null) => string | undefined) => {
  const translations = getTasksTranslation();
  const sections = getMenu() as unknown as Record<string, Section>;
  return (i18nKey) => {
    const translated = i18nKey ? translations[i18nKey] : undefined;
    // A missing translation comes back as its own key.
    if (!translated || /^(countries:)?tasks\./.test(translated)) return undefined;
    return expandSectionLinks(translated, sections);
  };
};
